module.exports = __webpack_public_path__ + "static/flock-a84783e8b7c0fec7eaa56922bf5429c4.png";